/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import PageBox from "../../layouts/pageBox";
import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {ReactComponent as Email} from "../../assets/img/forms/email.svg";
import SEO from "../../components/SEO";

const Contact = () => {

    const { t, i18n } = useTranslation();

    const [success, setSuccess] = useState(false);
    const axiosJWT = useAxiosJTW();

    const data = {
        title: `${t('pages.contact')}`,
        subtitle: ''
    };

    const { control, register, handleSubmit, watch, reset, setError, formState: { errors }, trigger, clearErrors } = useForm({
        mode: "onChange"
    });

    const onSubmit = data => {

        axiosJWT.post('api/contactform', data).then( (response) => {

            if(response.data.success){
                setSuccess(true);
            }

        } ).catch((error) => {
            console.log(error);
        });


    };

    return (
        <>
            <SEO
                title={ t('pages.contact') }
                description={data.title}
            />
            <PageBox data={data}>
                <div className='page-body'>
                    <div className='login-row'>
                        <div className='login'>
                            <div className='login__title'>{t('pages.contact')}</div>

                            {success ? (
                                <div className="alert alert-success" role="alert">
                                    <p className="font-weight-bold mb-1">{t('pages.contactmessage')}</p>
                                </div>
                            ) : (
                                <form className='login-form' onSubmit={handleSubmit(onSubmit)}>

                                    <div className="form-group">
                                        <label htmlFor='fname'>{t('fields.fname')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='fname' className="form-control" type="text" {...register("fname",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.fnamePlace')}/>
                                        </div>
                                        { errors.fname && <small className="text-danger">{errors.fname?.message}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor='lname'>{t('fields.lname')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='lname' className="form-control" type="text" {...register("lname",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.lnamePlace')}/>
                                        </div>
                                        { errors.lname && <small className="text-danger">{errors.lname?.message}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor='loginEmail'>{t('fields.email')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='loginEmail' className="form-control" type="email" {...register("email",{required: `${t('fields.requiredfield')}`} )} placeholder={t('fields.emailPlace')}/>
                                            <span className='form-group__icon'><Email/></span>
                                        </div>
                                        { errors.email && <small className="text-danger">{errors.email?.message}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor='phone'>{t('fields.phone')}</label>
                                        <div className='form-group__wrap'>
                                            <input id='phone' className="form-control" type="text" {...register("phone",{
                                                // required: 'Required Field',
                                                minLength: {
                                                    value: 10,
                                                    message: 'At least 10 digits'
                                                },
                                            } )} placeholder={t('fields.phonePlace')}/>
                                        </div>
                                        { errors.phone && <small className="text-danger">{errors.phone?.message}</small>}
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor='message'>{t('fields.message')}</label>
                                        <div className='form-group__wrap'>
                                            <textarea id='message' className="form-control" {...register("message", {required: `${t('fields.requiredfield')}`})} placeholder={t('fields.messagePlace')}></textarea>
                                        </div>
                                        { errors.message && <small className="text-danger">{errors.message?.message}</small>}
                                    </div>

                                    <button type="submit" className='btn btn-primary btn-icon btn-icon-right btn-block'>{t('fields.send')}</button>

                                </form>
                            )}

                        </div>
                    </div>
                </div>
            </PageBox>
        </>
    );
};

export default Contact;
